module.exports = __webpack_public_path__ + "static/media/kharyalaMainImg.77e3481b.jpeg";